export const ACTIONS = {
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB'
}
